// src/components/course/CourseCreateForm.js
import React from "react";

function CourseCreateForm({
  type,
  onTypeChange,
  courseName,
  onCourseNameChange,
  onStart,
}) {
  const PRIMARY_COLOR = "rgb(0, 224, 198)";

  return (
    <div className="bg-white border border-gray-100 rounded-[24px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] space-y-6">
      {/* 1. 유형 선택 (버튼형 토글) */}
      <div>
        <p className="mb-3 text-sm font-bold text-gray-700 ml-1">유형 선택</p>
        <div className="flex gap-3">
          {["러닝", "산책"].map((item) => {
            const isActive = type === item;
            return (
              <button
                key={item}
                type="button"
                onClick={() => onTypeChange && onTypeChange(item)}
                className={`
                  flex-1 py-3.5 rounded-2xl text-sm font-bold transition-all
                  ${
                    isActive
                      ? "text-white shadow-md transform scale-[1.02]"
                      : "bg-gray-50 text-gray-400 border border-gray-100 hover:bg-gray-100"
                  }
                `}
                style={{
                  backgroundColor: isActive ? PRIMARY_COLOR : undefined,
                }}
              >
                {item === "러닝" ? "🏃 러닝" : "🚶 산책"}
              </button>
            );
          })}
        </div>
      </div>

      {/* 2. 코스 이름 입력 (회색 배경 + 안쪽 그림자) */}
      <div>
        <p className="mb-3 text-sm font-bold text-gray-700 ml-1">코스 이름</p>
        <input
          type="text"
          value={courseName}
          onChange={(e) =>
            onCourseNameChange && onCourseNameChange(e.target.value)
          }
          placeholder="나만의 코스 이름을 지어주세요"
          className="w-full h-14 px-5 rounded-2xl bg-gray-100 shadow-inner border-none text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[rgb(0,224,198)] transition-all font-medium"
        />
      </div>

      {/* 3. 시작 버튼 (민트색 메인 버튼) */}
      <div className="pt-2">
        <button
          type="button"
          onClick={onStart}
          className="w-full h-14 rounded-2xl text-white text-base font-bold shadow-lg hover:opacity-90 transition-all active:scale-[0.98]"
          style={{ backgroundColor: PRIMARY_COLOR }}
        >
          코스 만들기 시작
        </button>
      </div>
    </div>
  );
}

export default CourseCreateForm;
